<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <!-- Snackbar for notifications -->
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>

            <!-- Toolbar for filters -->
            <v-card class="box no-display">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Book Review Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-row justify="center" dense>
                    <!-- Academic Year Filter -->
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" item-value="id"
                            :items="ay_list" item-text="ay" label="Academic Year" outlined />
                    </v-col>

                    <!-- Standard Filter -->
                    <v-col cols="12" sm="3" md="3" class="pt-3" v-if="ay">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete rounded dense required v-model="standard" :items="standard_list"
                            item-text="standard" item-value="id" label="Standard" outlined multiple
                            @change="getCourseOffering(standard)" />
                    </v-col>

                    <!-- Subject Filter -->
                    <v-col cols="12" sm="3" md="3" class="pt-3" v-if="standard.length > 0">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="subject" item-value="id"
                            :items="subject_list" item-text="course" label="Subject" outlined multiple />
                    </v-col>

                    <!-- Fetch Report Button -->
                    <v-col cols="12" sm="3" md="3" class="pt-7" v-if="subject.length > 0">
                        <v-btn class="button" @click="getReport()" :loading="loader">Fetch Report</v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <br>
            <!-- Selected Filter Summary and Report Table -->
            <div>
                <v-card class="box no-display" v-if="bookReviewData && bookReviewData.length > 0">

                    <v-row dense>

                        <!-- search code shiv -->
                        <v-col cols="12" sm="4" md="4"></v-col>
                        <v-col cols="12" sm="5" md="5">
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                                hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1" md="1"></v-col>
                        <v-col cols="12" sm="1" md="1">
                            <v-btn rounded color="success" outlined @click="exportToExcel
                                ">
                                <v-icon color="success">mdi-export</v-icon>Export
                            </v-btn>
                        </v-col>
                        <v-col cols="12" sm="1" md="1"></v-col>
                    </v-row>
                    <br>
                    <div v-for="(bookData, index) in filteredItems" :key="index">

                        <div class="pl-3">
                            <v-simple-table class="d-inline-flex"
                                v-if="bookData.book_review_crt != '' && bookData.book_list != ''">
                                <thead>
                                    <tr>
                                        <th class="font-weight-bold">Academic Year</th>
                                        <th class="font-weight-bold">Standard</th>
                                        <th class="font-weight-bold">Subject</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{ bookData.ay }}</td>
                                        <td>{{ bookData.standard }}</td>
                                        <td>{{ bookData.subject }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </div>
                        <br>
                        <v-card class="box" v-if="bookData.book_review_crt != '' && bookData.book_list != ''">
                            <table class="styled-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Criteria</th>
                                        <th v-for="book in bookData.book_list" :key="book.id">{{ book.publisher_name }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- Book Information Rows -->
                                    <tr>
                                        <td></td>
                                        <td>Name of the Text Book</td>
                                        <td v-for="book in bookData.book_list" :key="book.id">{{ book.name }}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>Publisher</td>
                                        <td v-for="book in bookData.book_list" :key="book.id">{{ book.publisher_name }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>Author</td>
                                        <td v-for="book in bookData.book_list" :key="book.id">{{ book.author }}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>Front Cover</td>
                                        <td v-for="book in bookData.book_list" :key="book.id">
                                            <button @click="viewCover(book.front_cover_file)" class="view-btn">
                                                <v-icon class="fa fa-eye mr-2">mdi-eye</v-icon>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>Is Currently Used?</td>
                                        <td v-for="book in bookData.book_list" :key="book.id">
                                            <v-icon v-if="book.iscurrentlyused"
                                                color="success">mdi-check-circle-outline</v-icon>
                                            <v-icon v-else color="error">mdi-close-circle-outline</v-icon>
                                        </td>
                                    </tr>

                                    <!-- Book Review Criteria Rows -->
                                    <tr v-for="(criterion, index) in bookData.book_review_crt" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ criterion.ctr.name }}</td>
                                        <td v-for="review in criterion.book_review_list" :key="review.id">{{
                                            review.value }}
                                        </td>
                                    </tr>

                                    <!-- Additional Rows -->
                                    <tr>
                                        <td></td>
                                        <td>Is Recommended?</td>
                                        <td v-for="book in bookData.book_list" :key="book.id">
                                            <v-icon v-if="book.isrecommended"
                                                color="success">mdi-check-circle-outline</v-icon>
                                            <v-icon v-else color="error">mdi-close-circle-outline</v-icon>
                                            <button @click="editRecommandation(book.id, book.isrecommended)"
                                                class="edit-btn">
                                                <v-icon class="fa fa-edit"
                                                    color="indigo">mdi-pencil-box-outline</v-icon>
                                            </button>
                                        </td>
                                    </tr>
                                    <v-dialog v-model="RecommondationEdit" max-width="500">
                                        <v-card>
                                            <v-card-title>
                                                Is Recommonded ?
                                            </v-card-title>
                                            <v-card-text>
                                                <v-radio-group v-model="currentRecommondationStatus" row>
                                                    <v-radio label="Yes" :value="true"></v-radio>
                                                    <v-radio label="No" :value="false"></v-radio>
                                                </v-radio-group>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="secondary"
                                                    @click="RecommondationEdit = false;">Cancel</v-btn>
                                                <v-btn color="primary"
                                                    @click="saveBookRecommondation(currentBookId, currentRecommondationStatus)">Save</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                    <tr>
                                        <td></td>
                                        <td>Price</td>
                                        <td v-for="book in bookData.book_list" :key="book.id">{{ book.price }}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>Remark</td>
                                        <td v-for="book in bookData.book_list" :key="book.id">{{ book.remark }}</td>
                                    </tr>

                                    <tr>
                                        <td></td>
                                        <td>Review Date</td>
                                        <td v-for="book in bookData.book_list" :key="book.id">{{
                                            book.review_date }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-card>
                        <br>
                    </div>
                    <br>
                </v-card>
            </div>

        </v-container>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
import * as XLSX from 'xlsx';

export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        loader: false,
        snackbar_msg: "",
        search: "",
        snackbar: false,
        overlay: false,
        RecommondationEdit: false,
        currentRecommondationStatus: false,
        currentBookId: null,
        ay: "",
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        standard: "",
        subject: "",
        ay_list: [],
        standard_list: [],
        subject_list: [],
        bookReviewData: [], // Initialize as an empty array for data display
        color: ""
    }),
    computed: {
        filteredItems() {
            const searchLower = this.search.toLowerCase();

            return this.bookReviewData.filter((item) => {
                // Collect all searchable fields into a single text string
                const combinedText = [
                    item.name,
                    item.reg_no,
                    ...item.book_review_crt.flatMap((crt) => [
                        crt.ctr.name,
                        ...crt.book_review_list.map((review) => review.value)
                    ]),
                    ...item.book_list.flatMap((book) => [
                        book.publisher_name,
                        book.author,
                        book.price,
                        book.remark,
                        book.subject_display,
                        book.std_display,
                        book.name
                    ])
                ]
                    .filter(Boolean) // Remove any undefined or null values
                    .join(' ') // Combine into a single searchable string
                    .toLowerCase(); // Convert to lowercase for case-insensitive search

                // Check if the search term is in the combined text
                return combinedText.includes(searchLower);
            });
        }
    },
    methods: {

        editRecommandation(id, rcmd) {
            this.RecommondationEdit = true;
            this.currentBookId = id;
            this.currentRecommondationStatus = rcmd;
        },
        saveBookRecommondation(id, value) {
            const data = {
                review_id: id,
                review_value: value,

            }
            axios
                .post("BookReview/updateBookReviewRecommondationStatus", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("success", "Updated successfully");
                        this.getReport();
                        this.RecommondationEdit = false;
                        // this.fetch();
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("error", res.data.snackbar)
                    }
                    else {
                        this.showSnackbar("#b71c1c", "Something went wrong");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => {
                    this.closeDialogs();
                });
        },
        exportToExcel() {
            // Define worksheet data
            const ws_data = [];

            // Loop through bookReviewData to construct rows
            this.bookReviewData.forEach((bookData, index) => {
                if (bookData.book_review_crt && bookData.book_list && bookData.book_list.length > 0) {
                    // Add header for each book data section
                    ws_data.push(["Academic Year", "Standard", "Subject"]);
                    ws_data.push([bookData.ay, bookData.standard, bookData.subject]);
                    ws_data.push([]); // Empty row for spacing

                    // Add table headers
                    const headers = ["S.No", "Criteria"];
                    bookData.book_list.forEach(book => headers.push(book.publisher_name));
                    ws_data.push(headers);

                    // Add book information rows
                    const bookInfoRows = [
                        ["", "Name of the Text Book", ...bookData.book_list.map(book => book.name)],
                        ["", "Publisher", ...bookData.book_list.map(book => book.publisher_name)],
                        ["", "Author", ...bookData.book_list.map(book => book.author)],
                        ["", "Front Cover", ...bookData.book_list.map(book => book.front_cover_file ? `<a href="${this.basepath + book.front_cover_file}" target="_blank">View Cover</a>` : "")],
                        ["", "Is Currently Used?", ...bookData.book_list.map(book => book.iscurrentlyused ? "Yes" : "No")]
                    ];
                    ws_data.push(...bookInfoRows);

                    // Add criteria-based rows if `book_review_list` has data
                    if (bookData.book_review_crt.length > 0) {
                        bookData.book_review_crt.forEach((criterion, idx) => {
                            const row = [idx + 1, criterion.ctr.name, ...criterion.book_review_list.map(review => review.value)];
                            ws_data.push(row);
                        });
                    }

                    // Add additional rows
                    const additionalRows = [
                        ["", "Is Recommended?", ...bookData.book_list.map(book => book.isrecommended ? "Yes" : "No")],
                        ["", "Price", ...bookData.book_list.map(book => book.price)],
                        ["", "Remark", ...bookData.book_list.map(book => book.remark)],
                        ["", "Review Date", ...bookData.book_list.map(book => book.review_date)]
                    ];
                    ws_data.push(...additionalRows);

                    // Add empty row for separation between books
                    ws_data.push([]);
                }
            });

            // Create workbook and worksheet
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.aoa_to_sheet(ws_data);

            // Fix links to be clickable in the exported Excel file by using cell type 'hyperlink'
            ws_data.forEach((row, rowIndex) => {
                row.forEach((cell, colIndex) => {
                    if (typeof cell === 'string' && cell.includes('<a href=')) {
                        const urlMatch = cell.match(/href="([^"]*)"/);
                        const textMatch = cell.match(/>([^<]*)<\/a>/);
                        if (urlMatch && textMatch) {
                            const link = urlMatch[1];
                            const text = textMatch[1];
                            const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
                            ws[cellAddress] = { t: 's', v: text, l: { Target: link } };
                        }
                    }
                });
            });

            XLSX.utils.book_append_sheet(wb, ws, "BookReviewReport");

            // Export to Excel
            XLSX.writeFile(wb, "BookReviewReport.xlsx");
        },



        showLogo() {
            if (this.show_logo) {
                this.show_logo = false;
            } else {
                this.show_logo = true;
            }
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        getReport() {
            this.show = true;
            this.loader = true;
            this.bookReviewData = [];

            const data = {
                ay: this.ay,
                standard: this.standard,
                subject: this.subject
            };
            axios
                .post("/BookReview/fetchBookReviewReport", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.bookReviewData = res.data.book_review_data;
                        //this.book_list = res.data.book_list;


                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    }
                    this.loader = false;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.loader = false;
                })
                .finally(() => { });
        },
        onLoad() {
            axios
                .post("/BookReview/getTextBookPurchaseReport")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.ay_list = res.data.ay_list;
                        this.standard_list = res.data.standard_list;


                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => { });
        },
        getCourseOffering(standard) {
            this.subject = "";
            const formData = {
                standard: standard,


            };
            axios
                .post("/BookReview/getCourseOfferingsBystd", formData)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.subject_list = res.data.course_list;
                    } else {
                        //   window.console.log(res.data.msg);
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => { });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        formatDate(date) {
            if (!date) return 'N/A';
            const parsedDate = new Date(date);
            const day = String(parsedDate.getDate()).padStart(2, '0');
            const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
            const year = parsedDate.getFullYear();
            const hours = String(parsedDate.getHours()).padStart(2, '0');
            const minutes = String(parsedDate.getMinutes()).padStart(2, '0');

            return `${day}-${month}-${year} ${hours}:${minutes}`;
        },
        viewCover(coverPath) {
            // console.log("coverpath",coverPath);
            window.open(this.basepath + coverPath, "_blank");
        },
    },
    mounted() {
        this.onLoad();
        this.basepath = localStorage.getItem("awspath");
    },
    watch: {},
};
</script>
<style scoped>
tr,
td,
th {
    border: 1px solid #ccc;
    width: auto;
    font-size: small;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    /* img {
    width: 100% !important;
  } */

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .box {
        background-color: white !important;
        /* margin: 8px !important;
    padding: 8px; */
        border: none !important;
        /* overflow: hidden !important; */
    }

    @page {
        size: A4;
        margin-top: none !important;
        padding-top: none;
        /* size: 18in 17in; */
        size: 20in 17in;
    }
}

.styled-table {
    width: 100%;
    border-collapse: collapse;
}

.styled-table th,
.styled-table td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
}

.styled-table th {
    background-color: #f4f4f4;
}

.styled-table td {
    vertical-align: middle;
}

.simple-table th {
    font-size: 15px;
    text-align: center;
}

.simple-table tr {
    background-color: #eceff1;
}

.simple-table td,
.simple-table th {
    border: 1px solid black;
}

.simple-table {
    width: 40%;
    margin: auto;
    text-align: center;
}
</style>
